<template>
    <div class="importBox">
        <el-form ref="form" :model="form" label-width="110px" :rules="rules">
            <el-form-item label="客户所有模板" prop="templateId.id" style="width: 350px">
                <el-select v-model="form.templateId.id" placeholder="请选择客户模板" style="width: 100%">
                    <el-option :label="item.name" :value="item.id" v-for="item in templateArr"
                               :key="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div class="templateBtn" @click="download">下载模板</div>
        <el-upload
                class="upload-demo"
                :limit="1"
                :on-success="handleSuccess"
                accept=".xlsx,.xls"
                :headers="headers"
                :action="url"
                :on-exceed="handleExceed"
                :data="form.templateId"
                name="file"
                :before-upload="beforeUpload">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">请先在下载的Excel模板中添加数据，然后点击此处导入填好的Excel</div>
        </el-upload>
    </div>
</template>

<script>
    import { getClientList } from '../../../api/mediationCenter';
    import bus from '../../../components/common/bus';

    export default {
        name: 'importMediationCase',
        data() {
            return {
                url: process.env.VUE_APP_BASE_API + '/api/tiaojie_case_batch_import_center',
                headers: {
                    'Authorization': sessionStorage.getItem('token'),
                    'Comid': JSON.parse(sessionStorage.getItem('shenfen')).com_id
                },
                form: {
                    templateId: {
                        id: ''  //客户模板id
                    }
                },
                rules: {
                    'templateId.id': [
                        { required: true, message: '请选择客户模板', trigger: 'change' }
                    ]
                },
                templateArr: [],  //客户所有模板列表
                loading: false
            };
        },
        methods: {
            //下载模板
            download() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        window.open(process.env.VUE_APP_BASE_API + `/api/case_tpl_download?id=${this.form.templateId.id}`, '_blank');
                    } else {
                        return false;
                    }
                });
            },
            handleSuccess(response, file, fileList) {
                if (response.code == 200) {
                    this.$message.success(response.msg);
                    bus.$emit('close_current_tags');
                    this.$router.push('/mediationCenter');
                } else {
                    this.$message.error(response.msg);
                }
            },
            handleExceed(files, fileList) {
                if (fileList.length >= 1) {
                    this.$message.error('只能上传1个文件');
                }
            },
            beforeUpload(file) {
                if (!this.form.templateId.id) {
                    this.$message.error('请先选择模板');
                    return false; // 阻止上传
                }
                return true; // 允许上传
            }
        },
        created() {
            getClientList().then(res => {
                if (res.code == 200) {
                    this.templateArr = res.data.list;
                } else {
                    this.$message.error(res.msg);
                }
            });
        }
    };
</script>

<style scoped lang="less">
    .importBox {
        padding: 30px;
        background-color: #ffffff;
        border-radius: 5px;
    }

    .templateBtn {
        width: 100px;
        height: 40px;
        background-color: #3E62F6;
        color: #fff;
        line-height: 40px;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
        margin: 20px 0px;
    }

    .upload-demo {
        margin-top: 20px;
    }
</style>
